const ITEMS = [
    "JEE Main & Advanced",
    "NEET-UG",
    "CBSE Boards 8-12",
    "Foundation Batches",
    "SSC & Banking",
    "Daily Doubt Support",
    "Crash Courses",
];

export default function Marquee() {
    return (
        <div
            className="marquee border-y border-white/10 bg-[#0F131D]/70 py-6"
            data-testid="marquee-ticker"
        >
            <div className="marquee-track">
                {[0, 1].map((copy) => (
                    <div
                        key={copy}
                        aria-hidden={copy === 1}
                        className="flex items-center gap-12 pr-12"
                    >
                        {ITEMS.map((item, i) => (
                            <span
                                key={i}
                                className="flex items-center gap-12 whitespace-nowrap f-display text-xl sm:text-2xl font-extrabold uppercase tracking-tight text-slate-400"
                            >
                                {item}
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    className="shrink-0"
                                >
                                    <path
                                        d="M7 0L8.6 5.4L14 7L8.6 8.6L7 14L5.4 8.6L0 7L5.4 5.4L7 0Z"
                                        fill="#FF5500"
                                    />
                                </svg>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
